import { useEffect, useRef, useState } from "react";
import "../styles/OurVision.css";

export default function TimelineSection() {
  const progressRef = useRef(null);
  const dotsRef = useRef([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 565);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Desktop positions (horizontal - width)
    const desktopPositions = [18, 37.3, 61.3, 82, 100];
    
    // Mobile positions (vertical - height)
    const mobilePositions = [0, 28, 50, 72, 100];
    
    const positions = isMobile ? mobilePositions : desktopPositions;
    let dotIndex = 0;

    const animateToNextDot = () => {
      if (!progressRef.current || dotsRef.current.length === 0) {
        setTimeout(animateToNextDot, 100);
        return;
      }
      
      if (dotIndex >= positions.length) {
        progressRef.current.style.transition = "none";
        
        if (isMobile) {
          progressRef.current.style.height = "0%";
        } else {
          progressRef.current.style.width = "0%";
        }
        
        dotsRef.current.forEach(dot => dot?.classList.remove("active"));
        dotIndex = 0;
        setTimeout(animateToNextDot, 1800);
        return;
      }
      
      if (isMobile) {
  progressRef.current.style.transition = "height 1.2s ease";
  progressRef.current.style.height = positions[dotIndex] + "%";
  progressRef.current.style.width = "6px"; // 🔥 ensure visible
}

       else {
        progressRef.current.style.transition = "width 1.2s ease";
        progressRef.current.style.width = positions[dotIndex] + "%";
      }
      
      dotsRef.current[dotIndex]?.classList.add("active");
      dotIndex++;
      setTimeout(animateToNextDot, 2000);
    };
    
    setTimeout(animateToNextDot, 100);
  }, [isMobile]);

  return (
    <section className="timeline-section" style={{ position: 'relative', overflow: 'visible' }}>
      {/* Decorative Vectors Behind Timeline */}
      <img
        src="/assets/images/vector-bottom-left1.png"
        alt=""
        className="timeline-vector timeline-vector-bottom-left"
        aria-hidden="true"
      />
      <img
        src="/assets/images/vector-top-right1.png"
        alt=""
        className="timeline-vector timeline-vector-top-right"
        aria-hidden="true"
      />
         
      <button className="vision-btn">Our Vision</button>
      <h2 className="timeline-heading">
        From Talent Services to Technology Solutions
      </h2>
      
      <div className="timeline-wrapper">
        {/* TIMELINE LINE */}
        <div className="timeline-line">
          <div className="timeline-progress" ref={progressRef}></div>
          <span className="dot dot-1" ref={el => (dotsRef.current[0] = el)}></span>
          <span className="dot dot-2" ref={el => (dotsRef.current[1] = el)}></span>
          <span className="dot dot-3" ref={el => (dotsRef.current[2] = el)}></span>
          <span className="dot dot-4" ref={el => (dotsRef.current[3] = el)}></span>
          <span className="dot dot-5" ref={el => (dotsRef.current[4] = el)}></span>
        </div>
        
        {/* 2024 */}
        <div className="timeline-item top" style={{ left: isMobile ? "auto" : "0%" }}>
          <div className="timeline-content">
            <div className="text-2024">
              <h3>2024</h3>
              <p>Company Launch & Incorporated</p>
            </div>
            <div className="dotted-line-1"></div>
          </div>
        </div>
        
        {/* 2024 Mid */}
        <div className="timeline-item bottom" style={{ left: isMobile ? "auto" : "23.9%" }}>
          <div className="timeline-content">
            <div className="text-mid">
              <h3>2024 Mid</h3>
              <p>Onboarded 20+ clients</p>
            </div>
            <div className="dotted-line-2"></div>
          </div>
        </div>
        
        {/* 2025 */}
        <div className="timeline-item top" style={{ left: isMobile ? "auto" : "50%" }}>
          <div className="timeline-content">
            <div className="text-2025">
              <h3>2025</h3>
              <p>Team scaled to 10+ employees</p>
            </div>
            <div className="dotted-line-3"></div>
          </div>
        </div>
        
        {/* 2026 */}
        <div className="timeline-item bottom" style={{ left: isMobile ? "auto" : "75%" }}>
          <div className="timeline-content year-2026">
            <div className="text">
              <h3>2026</h3>
              <p>
                Becoming a Tech-<br className="mobile-only" />
                Enabled Company
              </p>
            </div>
            <div className="dotted-line-4"></div>
          </div>
        </div>
        
        {/* Future */}
        <div className="timeline-item top" style={{ left: isMobile ? "auto" : "102%" }}>
          <div className="timeline-content future-item">
            <div className="text">
              <h3>Future</h3>
                <p>
  Trusted Software<br />
  Development Partner
</p>
            </div>
            <div className="dotted-line-5"></div>
          </div>
        </div>
      </div>
    </section>
  );
}